<template>
  <div>
  
  
 <!-- start company info header -->
  
  <div style="margin-bottom: 90px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>
  
  <!-- end company info header -->
  
   <h4  slot="header" class="title">
     Shareholder Information
    </h4>
 <card class="form-horizontal">

    
    
   <div style="padding:10px 0px 20px 30px;">
  <br/><strong>First Name:</strong> {{person.first_name}}
  <br/><strong>Last Name:</strong> {{person.last_name}}
   <br/><br/> 
    
  <br/><strong>ID No:</strong> {{person.gov_id}}
  <br/><strong>Citizenship:</strong> {{getCitizenship(person.citizenship)}}
  <br/><strong>Nationality:</strong> {{getCountry(person.nationality)}}
  
  <br/><br/> 
   <br/><strong>Address:</strong> {{person.address_1}}
   <br/><strong>Email:</strong> {{person.email}}
   <br/><strong>Contact No:</strong> {{person.contact_num}}
   </div>
   
   
  </card>
       
  <div style="margin-top:100px;">     
    <h4  slot="header" class="title">
     Edit Shares Information
    </h4>
   </div>       
   <card>
    
    
    
    
   	 <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >Share Type</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">
        	<span v-if="model.share_type==1">Ordinary</span>
        	<span v-if="model.share_type==2">Preference</span>
        </div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >Num Of Shares</label>
      <div class="col-sm-7">
         <div style="max-width:300px;">
         <fg-input type="text"
                  name="num_shares"
                  v-model="model.num_shares">
        </fg-input>
        </div>
        
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >Paid-up Capital ( {{model.currency}})</label>
      <div class="col-sm-7">
        <div   style="max-width:300px;">
           <fg-input type="text"
                  name="paid_up_capital"
                  v-model="model.paid_up_capital">
        </fg-input>
      </div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
   <div v-if="0" class="text-center"  style="margin-top:30px;margin-bottom:50px;">
   <p-button   type="default" @click.prevent="goToCreateTaskDetails">OLD: Create Share Certificate & New Task</p-button>
      <p-button   type="default" @click.prevent="goToResoBuilderShareCert">Create Share Certificate & New Task</p-button>
    </div>
  
   
   
   </card>
   

		<p-button type="info"  @click="editShareholder()" >
                Update Shareholding
        </p-button>
	
	
	


  </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  import {CommonService} from 'src/services/common.service'
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {
     
     
       if(this.$route.params.oid!=0){
     		this.createForm = false;
     		
     		let uri = this.$base_url+'/api/v1/shareholders/'+ this.$route.params.shid+"/entity/"
     		+ this.$route.params.eid + "/" + this.$route.params.type ;
			 ApiService.get(uri).then(response => {
				
				this.model = response.data.shareholder;
				this.person = response.data.shareholder.person;
				this.coy = response.data.entity_info;
				this.shareCerts = response.data.shareholder.share_certificates;
			    
			
			})

     	}
     	
    
      	
      	
      
    },
    
     
    data () {
      return {
        coy:[],
    	eid: this.$route.params.eid,
    	shid: this.$route.params.shid,
    	shareCerts: [],
    	person:[],
        model: {
          first_name: '',
          last_name: '',
          address_1: '',
          status: 1,
          is_contact_person: 2,
          date_appt: '',
          position:'Director',
          nationality:'',
          gov_id:'',
          email:'',
          contact_num:'',
          eid: this.$route.params.eid

        },
        modelValidations: {
          first_name: {
            required: true
          },
          last_name: {
            required: true,
          },
          address_1: {
            required: true,
          },
          status: {
          	required: true,
          },
          is_contact_person: {
            required: true,
          },
          date_appt: {
            required: true,
          },
           position: {
            required: true,
          },
          nationality: {
            required: true,
          },
          gov_id: {
            required: true,
          },
          email: {
            required: true,
            email: true
          },
          contact_num: {
            required: true,
          },
          
        },
        
        selects: {
          officer_status: [
            {value: 1, label: 'Active'},
            {value: 2, label: 'Resigned'},
		   ],
		  is_contact:[
            {value: 1, label: 'Yes'},
            {value: 2, label: 'No'},
		   ] 
        },
      }
    },
    methods:{
     scRowClassName({ row }){
    		if(row.status == 4){
    			return "table-success";
    		}
    		else if(row.status == 5){
    			return "cs-strikethrough";
    		}
    	
      },
      getCitizenship(code){
      		if(code){
      			return CommonService.getCitizen(code);
      		}
      },
      getCountry(code){
      		if(code){
      			return CommonService.getCountry(code);
      		}
      },
      goToEditShareholder(){
      	this.$router.push( '/edit-shareholder-details/'+ this.model.id+"/entity/"+this.$route.params.eid+"/" + this.model.share_type);
      },
      goToCertTask(row){
      	this.$router.push( '/edit-task/'+row.task_id+'/entity/'+this.$route.params.eid)
      },
      goToCert(row){
      	this.$router.push( '/view-share-cert/'+row.id+'/entity/'+this.$route.params.eid)
      },
      goToCreateTaskDetails(){
       		this.$router.push( '/create-task-details/'+ this.$route.params.eid+"/sc/"+this.$route.params.shid +"/0" + "/"+this.$route.params.type)
       },
       goToResoBuilderShareCert(){
       		this.$router.push( '/resolution-builder/0/entity/'+this.$route.params.eid)  
       },
     goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.coy.id);
	    },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      editShareholder() {
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
    		
  		  } else {
    		let uri = this.$base_url+'/api/v1/shareholders/edit-details/'+this.model.id +'/entity/'+this.$route.params.eid;
      		ApiService.post(uri, this.model).then(response => {
      	
         			this.$router.push('/edit-shareholder/'+ this.model.id +'/entity/'+ this.$route.params.eid + "/" + this.model.share_type)
         		
     		 })
  		  }
        
         
        })
      },///end validate+edit
      
      
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


